// extracted by mini-css-extract-plugin
module.exports = {"taskDetailsCell":"style_taskDetailsCell__2pl3c","stats":"style_stats__2ZwRp","states":"style_states__3vy0J"};